<div class="slider-container" *ngIf="photos() as photoList">
  <div class="slider-content">
    <img
      class="slider__main-img"
      loading="lazy"
      [src]="getCurrentPhoto()"
      alt="No photo" />

    <div class="slider-controls">
      <button
        mat-mini-fab
        color="primary"
        class="arrow left-arrow"
        (click)="prevPhoto()">
        <mat-icon>chevron_left</mat-icon>
      </button>
      <button
        mat-mini-fab
        color="primary"
        class="arrow right-arrow"
        (click)="nextPhoto()">
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>
  </div>

  <div class="slider__thumbnails">
    <img
      *ngFor="let photo of photoList; let i = index"
      [src]="photo"
      [class.active]="i === activePhoto()"
      (click)="setActivePhoto(i)"
      class="slider__thumb"
      alt="Thumbnail {{ i }}"
      loading="lazy" />
  </div>
</div>
